import React from 'react'

import Banner from '../Banner/Banner'
// import PlainChart from '../MarketComponents/PlainChart'

const Trending = () => {
  return (
    <>
    <Banner/>
    {/* <PlainChart/> */}
    </>
  )
}

export default Trending